'use strict';

var SplashPageController = function SplashPageController($scope, ScheduleChangeConstants) {
  $scope.wizardNames = ScheduleChangeConstants.ENTITIES;
  $scope.showWizard = function (wizard) {
    $scope.wizardShown = wizard;
  };
};
SplashPageController.$inject = ['$scope', 'ScheduleChangeConstants'];
module.exports = SplashPageController;